var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","stroke":"red","fillRule":"evenodd","strokeLinecap":"square"},React.createElement("path",{"d":"M10 0 v16 M16 10 l-6 6 -6-6"})));
}

ArrowDown.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
